export const WHATSAPP_NUMBER = "971556069046";
export const waLink = (msg) =>
  `https://wa.me/${WHATSAPP_NUMBER}${msg ? `?text=${encodeURIComponent(msg)}` : ""}`;

/* Single "Ask a question" channel used site-wide */
export const askLink = (topic = "") =>
  waLink(`Hi Ah-Jin Group — I have a question${topic ? ` about ${topic}` : ""}.`);
